var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyDollarBoxLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00488 3.00391H21.0049C21.5572 3.00391 22.0049 3.45162 22.0049 4.00391V20.0039C22.0049 20.5562 21.5572 21.0039 21.0049 21.0039H3.00488C2.4526 21.0039 2.00488 20.5562 2.00488 20.0039V4.00391C2.00488 3.45162 2.4526 3.00391 3.00488 3.00391ZM4.00488 5.00391V19.0039H20.0049V5.00391H4.00488ZM8.50488 14.0039H14.0049C14.281 14.0039 14.5049 13.7801 14.5049 13.5039C14.5049 13.2278 14.281 13.0039 14.0049 13.0039H10.0049C8.62417 13.0039 7.50488 11.8846 7.50488 10.5039C7.50488 9.1232 8.62417 8.00391 10.0049 8.00391H11.0049V6.00391H13.0049V8.00391H15.5049V10.0039H10.0049C9.72874 10.0039 9.50488 10.2278 9.50488 10.5039C9.50488 10.7801 9.72874 11.0039 10.0049 11.0039H14.0049C15.3856 11.0039 16.5049 12.1232 16.5049 13.5039C16.5049 14.8846 15.3856 16.0039 14.0049 16.0039H13.0049V18.0039H11.0049V16.0039H8.50488V14.0039Z",
    fill: "#E65425"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyDollarBoxLine);
export default __webpack_public_path__ + "static/media/money-dollar-box-line.5f16014eb846a97fc79d24863beb2ef5.svg";
export { ForwardRef as ReactComponent };